import { render, staticRenderFns } from "./tmAudioWave.vue?vue&type=template&id=fc52f4d8&"
import script from "./tmAudioWave.vue?vue&type=script&lang=js&"
export * from "./tmAudioWave.vue?vue&type=script&lang=js&"
import style0 from "./tmAudioWave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports